var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contador_tempo"},[_c('div',{staticClass:"conteudo"},[_c('p',[_vm._v("Tempo para sessão expirar: "+_vm._s(this.expiram_em)+" minutos")])])])}
var staticRenderFns = []

export { render, staticRenderFns }